import React from 'react'
import { TableProps } from 'antd/lib/table'

import { ColumnProps } from 'src/components/Ant/Table'
import { Table, Text, Tooltip } from 'src/components/Ant'
import { R5Data } from 'src/store/ducks/reports/types'
import { currencyMask } from 'src/components/Formik'

function abbreviate(word: string, index: number) {
  return index
    ? /[A-Z]/.test(word.charAt(0))
      ? `${word.charAt(0)}.`
      : /[0-9]/.test(word.charAt(0))
      ? word
      : null
    : word
}

const columns: ColumnProps<R5Data>[] = [
  {
    align: 'center',
    dataIndex: 'request_number',
    key: 'request_number',
    render: (value: string) => <Text>#{value}</Text>,
    title: 'web.report.5.data.request-number',
    width: 50
  },
  {
    align: 'center',
    dataIndex: 'receipt_eticket_code',
    key: 'receipt_eticket_code',
    render: (value: string) => <Text>#{value}</Text>,
    title: 'web.report.5.data.receipt-eticket-code'
  },
  {
    align: 'center',
    dataIndex: 'traveler',
    ellipsis: true,
    key: 'traveler',
    render: (value: string) => (
      <Tooltip title={<>{value}</>}>
        <Text>{value.split(' ').map(abbreviate).join(' ')}</Text>
      </Tooltip>
    ),
    title: 'web.report.5.data.traveler'
  },
  {
    align: 'center',
    dataIndex: 'receipt_currency',
    ellipsis: true,
    key: 'receipt_currency',
    render: (value: number) => <Text>{value}</Text>,
    title: 'web.report.5.data.receipt-currency'
  },
  {
    align: 'right',
    dataIndex: 'receipt_enxange_rate',
    ellipsis: true,
    key: 'receipt_enxange_rate',
    render: (value: number) => (
      <Text>
        {
          currencyMask({
            formatStr: true,
            precision: 4,
            value
          }).maskedValue
        }
      </Text>
    ),
    title: 'web.report.5.data.receipt-exchange-rate'
  },
  {
    align: 'right',
    dataIndex: 'receipt_value',
    ellipsis: true,
    key: 'receipt_value',
    render: (value: number) => (
      <Text>
        {
          currencyMask({
            formatStr: true,
            precision: 2,
            value
          }).maskedValue
        }
      </Text>
    ),
    title: 'web.report.5.data.receipt-value'
  },
  {
    align: 'right',
    dataIndex: 'receipt_total_sum',
    ellipsis: true,
    key: 'receipt_total_sum',
    render: (value: number) => (
      <Text>
        {
          currencyMask({
            formatStr: true,
            precision: 2,
            value
          }).maskedValue
        }
      </Text>
    ),
    title: 'web.report.5.data.receipt-total-sum'
  }
]

function TableDetail({ ...props }: TableProps<R5Data>) {
  return (
    <Table
      {...props}
      className="table-striped table-sm"
      columns={columns}
      pagination={false}
    />
  )
}

export default TableDetail
